import * as Yup from 'yup'
import { Form} from 'react-bootstrap'
import { CustomFormControl } from '../../../../StyledComponents';
import { checkText } from '../ValidationRules';

export const Schema = (settings) => Yup.object().shape({
    salaryRequest: Yup.number()
        .nullable(true)
        .typeError("Nur Zahlenwerte ohne Sonderzeichen")
        .positive("Nur positive Zahlen")
        .integer("Nur ganze Zahlen")
        .test("Length", "Zahl ist zu groß", val => {
            if (val) return val <= 999999999;
            return true;
        }),
    periodOfCancellation: checkText(settings),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            <Form.Group className="mb-3" controlId="formSalaryRequest">
                <Form.Label>Gehaltsvorstellung</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Gehaltsvorstellung eingeben"
                    type="text"
                    name="salaryRequest"
                    value={values.salaryRequest || ''}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.salaryRequest && !errors.salaryRequest}
                    isInvalid={touched.salaryRequest && errors.salaryRequest}
                    maxLength={9}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.salaryRequest}
                </Form.Control.Feedback>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formPeriodOfCancellation">
                <Form.Label>Kündigungsfrist</Form.Label>
                <CustomFormControl
                    colors={colors}
                    placeholder="Kündigungsfrist eingeben"
                    type="text"
                    name="periodOfCancellation"
                    value={values.periodOfCancellation}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    isValid={touched.periodOfCancellation && !errors.periodOfCancellation}
                    isInvalid={touched.periodOfCancellation && errors.periodOfCancellation}
                    maxLength={settings.textInputLimit}
                />
                <Form.Control.Feedback type="invalid">
                    {errors.periodOfCancellation}
                </Form.Control.Feedback>
            </Form.Group>
        </>
    );
};